import React, { useEffect } from 'react';
import * as Pages from './pages';
import './styles/global.scss';
import './styles/tailwind.output.css';
import objectFitImages from 'object-fit-images';
import { StyledToastContainer } from 'components/ui/StyledToast';
import { LocalizationProvider } from 'context/localization.context';

import {
	//polyfillFind,
	polyfillForEach,
	polyfillDownload,
	//polyFillStartsWith,
} from 'common/polyfills';

import StandardLayout from 'layouts/StandardLayout';
import LogoOnlyLayout from 'layouts/LogoOnlyLayout';
import ViewProvider from 'context/view.context';
import { SiteTypeContext } from 'context/siteType.context';

// polyfillFind();
polyfillForEach();
polyfillDownload();
// polyFillStartsWith();

const App = (props) => {
	const { footer, header, api, localization, siteType } = props.framework;
	let Page = Pages.get(props);

	useEffect(() => {
		objectFitImages();

		if (window.dataLayer && siteType === 'Lindab') {
			window.dataLayer.push({
				event: 'epilogin_status',
				loggedIn: header.userObject.customers.length > 0 ? true : false,
			});
		}
		//eslint-disable-next-line
	}, []);

	/**setting site background color and font based on site type */
	useEffect(() => {
		document.body.classList.add(
			siteType === 'LindabGroup' ? 'theme-lindab-group' : 'theme-lindab'
		);
	}, [siteType]);

	const PageLayout =
		props.modelType === 'CheckoutPage' ? LogoOnlyLayout : StandardLayout;

	return (
		<ViewProvider>
			<LocalizationProvider model={localization}>
				<SiteTypeContext.Provider value={siteType}>
					<PageLayout
						header={header}
						footer={footer}
						api={api}
						modelType={props.modelType}
					>
						<Page {...props} />
						<StyledToastContainer />
					</PageLayout>
				</SiteTypeContext.Provider>
			</LocalizationProvider>
		</ViewProvider>
	);
};

export default App;
